var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useFormContext } from "react-hook-form";
import useHasPermission from "../../Hooks/useHasPermission";
import { PersonMultiSearch } from "../Person/PersonSearch";
import PersonTypeDomainService from "../../../Domain/PersonType/PersonType.service";
import SearchField from "../../Form/SearchField";
import { AlertInfo } from "../../UI/StandardAlerts/StandardAlerts";
import useService from "../../Hooks/useService";
import PersonService from "../../../Services/Person.service";
import Loading from "../../UI/Loading/Loading";
import ListService from "../../../Services/Shared/List.service";
/**
 * We have to treat limiting to people's caseloads in parts of the app with care because there are some people that
 * can only use filters limited to their caseload.  This component does the heavy lifting.  If a person can search outside
 * their caseload, it's a normal caseload select.  If they can't, it disables the input and only allows the person to
 * limit the selection to their caseload.
 *
 * TODO when a user that can't search outside limits to their caseload, allow them to undo and set it back to whatever it was.
 *
 */
const AdHocFilterSelectField = ({ name, disabled, }) => {
    // here we are checking for permission CAN_SEE_FULL_PROFILE_FOR_ALL_STUDENTS because it dictates
    // the ability to access Everyone Filters and view student profiles outside the caseload
    const canSearchOutsideCaseload = useHasPermission("CAN_SEE_FULL_PROFILE_FOR_ALL_STUDENTS");
    const { setValue, watch } = useFormContext();
    // This is annoying, but because the currentUser hook returns an API person that doesn't have all the properties we need, we have to
    // fetch a personlite when we want to limit it to a caseload
    // Pass in setValue as sv just in case it changes
    const [setLimitState, setCaseloadToCurrentUser] = useService((sv) => __awaiter(void 0, void 0, void 0, function* () {
        const currentUser = yield PersonService.me();
        sv(name, [currentUser]);
    }));
    const currentValue = watch(name);
    let warning = null;
    if (canSearchOutsideCaseload === false) {
        if (currentValue == null || ListService.isEmptyArray(currentValue)) {
            warning = (_jsx(AlertInfo, { message: "You do not have permission to search outside your caseload.  Any filter you select here will be limited to your caseload." }));
        }
        else {
            warning = (_jsx(AlertInfo, { message: "You do not have permission to search outside your caseload.  You cannot change this value to anything other than yourself." }));
        }
    }
    React.useEffect(() => {
        if (canSearchOutsideCaseload === false) {
            setCaseloadToCurrentUser(setValue);
        }
    }, [canSearchOutsideCaseload, setCaseloadToCurrentUser, setValue]);
    return (_jsxs("div", { children: [_jsx(SearchField, { label: "Caseload", noBottomMargin: true, name: name, as: (provided) => (_jsx(PersonMultiSearch, Object.assign({}, provided, { personTypeInternalNames: [
                        PersonTypeDomainService.StaffPersonTypeInternalName,
                        PersonTypeDomainService.FacultyPersonTypeInternalName,
                    ] }))), disabled: !canSearchOutsideCaseload || disabled, helpText: "Apply additional caseload filtering to the selected filter.  This will not affect the filter." }), _jsxs("button", { className: "btn btn-link pl-0 mb-2", disabled: setLimitState.isLoading, onClick: () => {
                    setCaseloadToCurrentUser(setValue);
                }, children: ["Limit to my caseload", setLimitState.isLoading && _jsx(Loading, { className: "ml-2" })] }), warning] }));
};
export default AdHocFilterSelectField;
